/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Quick_Products_PlaceholderInputs */

const vi_order_quick_products_placeholder = /** @type {(inputs: Order_Quick_Products_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VD: 2 thùng bia Tiger
1 thùng Coca Cola
3 chai nước suối`)
};

/**

* @param {Order_Quick_Products_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_quick_products_placeholder = /** @type {((inputs?: Order_Quick_Products_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Quick_Products_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_quick_products_placeholder(inputs)
});